import { localStorageIgnoredSmartNotes } from './active-errors.model';

export namespace ActiveErrorsHelper {
  export const getLocalStorageIgnoredSmartNotes = (): string[] => {
    return localStorage.getItem(localStorageIgnoredSmartNotes)?.split(',') ?? [];
  };

  export const setLocalStorageIgnoredSmartNotes = (id: string): void => {
    const smartNotes = getLocalStorageIgnoredSmartNotes();
    smartNotes.push(id);

    localStorage.setItem(localStorageIgnoredSmartNotes, smartNotes.join(','));
  };
}
